// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Icio","inner":"Footer_inner__2FNGO","nextIcon":"Footer_nextIcon__2Uc-5","innerLeft":"Footer_innerLeft__3ohVX"};